<div class="card" style="height:100%">
  <div class="card-header">
<div class="row">
  <div class="col-12 text-center">
    <h4 style="color: #9b7544"> Otp verification</h4>
  </div>
</div>
  </div>
  <div class="card-body">
    <div class="form group">
      <label>Enter Otp Here</label>
      <input type="taxt" [(ngModel)] = "otp">
    </div>
  </div>
  <div class="card-footer" style="margin-bottom:0px">
<div class="row" style="margin:3px">
  <div class="col-6 text-center" *ngIf="otp">
<button class="btn btn-success btn-block" (click)=" postForOtp()">Confirm</button>
  </div>
  <div class="col-6 text-center">
      <button class="btn btn-success btn-block"  mat-dialog-close>Cancel</button>
        </div>
</div>
  </div>
</div>
